// extracted by mini-css-extract-plugin
export default {"border_color":"style_border_color__TXWGi","cursor_pointer":"style_cursor_pointer__Mwx6A","reviews":"style_reviews__8qqYt","scrollbar_custom":"style_scrollbar_custom__8zV5H"};